<mn-svg name="logo" />

<div class="center b-bg" [style.--h-c]="hC()" [style.--h-w.px]="hW()">
  <b class="t-no">{{ prefix }}{{ ba() }}</b>
</div>

<mn-svg data-ui-sound class="right cu-p i-10" mnAnalyticsClick="burger" mnClickArea name="menu" (click)="burger()" />
